import type { DealerSageMappings, DealerSageProductRow, SageNominal } from '../types/dealerSageMappings.types';
import { shortId } from './shortId';

export interface SageTableRow {
    key: string;
    productId: string;
    product: DealerSageProductRow;
    nominal: SageNominal | null;
}

export const buildSageTableRows = ({ products }: DealerSageMappings): SageTableRow[] =>
    products.map((product) => ({
        key: product.productId,
        productId: product.productId,
        product,
        nominal: product.nominal,
    }));

export const sageDraftInputId = (field: 'code' | 'name' | 'date', rowKey: string): string => `sage-${field}-${rowKey}`;

export const sageCodeInputId = (rowKey: string): string => sageDraftInputId('code', rowKey);

export const sageRowSubject =({ product }: SageTableRow): string =>
    product.productName ?? `unknown product ${shortId(product.productId)}`;
